<div class="section-header d-flex justify-content-between align-items-center p-3 bg-light border-bottom">
  <h5 class="mb-0 fw-bold">Datos Generales del Centro de Trabajo</h5>
  <div class="d-flex gap-2">
    <app-button
      [label]="isEditMode ? 'Actualizar' : 'Guardar datos generales'"
      icon="save"
      variant="primary"
      [loading]="isSaving"
      [disabled]="isLoadingCatalogs"
      (click)="onSave()">
    </app-button>
  </div>
</div>

<div *ngIf="isLoadingCatalogs" class="loading-catalogs text-center py-5">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
  <p class="text-muted">Cargando catálogos...</p>
</div>

<form *ngIf="!isLoadingCatalogs" [formGroup]="formGroup" class="merchant-location-form container-fluid">
  <div class="row mb-3">
    <div class="col-md-4">
      <app-field [control]="formGroup.get('name')" [config]="{ label: 'Nombre del centro de trabajo', type: 'text', required: true }">
      </app-field>
    </div>
    <div class="col-md-3" (click)="onSlugClick()">
      <app-field [control]="formGroup.get('slug')" [config]="{ label: 'Slug (URL amigable)', type: 'text', required: true, placeholder: 'ej: mi-local-madrid' }">
      </app-field>
    </div>

    <div class="col-md-1 d-flex align-items-end gap-1">
      <button
        mat-icon-button
        type="button"
        (click)="generateSlugFromName()"
        [disabled]="!formGroup.get('name')?.value"
        class="mb-3"
        color="primary"
        matTooltip="Generar slug desde el nombre">
        <mat-icon>autorenew</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        (click)="openSlugOnboarding()"
        class="mb-3"
        matTooltip="¿Qué es el slug?">
        <mat-icon color="accent">help_outline</mat-icon>
      </button>
    </div>
    <div class="col-md-4">
      <app-autocomplete [control]="formGroup.get('statusMerchantLocationId')" [config]="{
        label: 'Estado',
        placeholder: 'Seleccionar estado...',
        options: locationStatusesOptions,
        required: true
      }">
      </app-autocomplete>
    </div>
    <div class="col-md-4">
      <app-autocomplete [control]="formGroup.get('merchantLocationCategoryId')" [config]="{
        label: 'Categoría del centro',
        placeholder: 'Seleccionar categoría...',
        options: merchantLocationCategoriesOptions,
        required: true
      }">
      </app-autocomplete>
    </div>

    <div class="col-md-4 d-flex align-items-center">
      <mat-checkbox formControlName="isMainLocation" class="mt-3">
        Centro de trabajo principal
      </mat-checkbox>
    </div>
    <div class="col-md-4">
      <app-field [control]="formGroup.get('displayOrder')" [config]="{ label: 'Orden de visualización', type: 'number' }">
      </app-field>
    </div>
    <div class="col-md-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Descripción</mat-label>
        <textarea matInput formControlName="description" rows="3"></textarea>
        <mat-error *ngIf="formGroup.get('description').hasError('maxlength')">
          Máximo 1000 caracteres
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-md-12">
      <h6 class="fw-bold mb-2">Dirección</h6>
    </div>

    <!-- GOOGLE_MAPS_DISABLED - restore when API key available
    <div class="col-md-12 mb-3" [hidden]="!googleMapsReady && !googleMapsError">
      <div class="input-group" [hidden]="googleMapsError">
        <span class="input-group-text bg-white">
          <mat-icon class="text-muted" style="font-size:18px;line-height:18px">search</mat-icon>
        </span>
        <input
          #googleMapsInput
          type="text"
          class="form-control"
          placeholder="Busca la dirección en Google Maps para autocompletar..."
          autocomplete="off"
        />
      </div>
      <small class="text-muted" [hidden]="googleMapsError">Selecciona un resultado para rellenar los campos automáticamente. Puedes editarlos manualmente si lo necesitas.</small>
      <small class="text-warning" [hidden]="!googleMapsError">
        <mat-icon style="font-size:14px;vertical-align:middle">warning</mat-icon> Google Maps no disponible. Introduce la dirección manualmente.
      </small>
    </div>
    END GOOGLE_MAPS_DISABLED -->


    <div class="col-md-6">
      <app-field [control]="formGroup.get('addressLine1')" [config]="{ label: 'Dirección línea 1', type: 'text', required: true }">
      </app-field>
    </div>
    <div class="col-md-6">
      <app-field [control]="formGroup.get('addressLine2')" [config]="{ label: 'Dirección línea 2', type: 'text' }">
      </app-field>
    </div>
    <div class="col-md-3">
      <app-autocomplete [control]="formGroup.get('countryCode')" [config]="{
        label: 'País',
        placeholder: 'Seleccionar país...',
        options: countriesOptions,
        required: true,
        onChange: onCountryChange.bind(this)
      }">
      </app-autocomplete>
    </div>
    <div class="col-md-3">
      <app-autocomplete [control]="formGroup.get('state')" [config]="{
        label: 'Provincia',
        placeholder: 'Seleccionar provincia...',
        options: provincesOptions,
        required: true,
        onChange: onStateChange.bind(this)
      }">
      </app-autocomplete>
    </div>
    <div class="col-md-3">
      <app-autocomplete [control]="formGroup.get('city')" [config]="{
        label: 'Ciudad / Municipio',
        placeholder: 'Seleccionar ciudad...',
        options: municipalitiesOptions,
        required: true
      }">
      </app-autocomplete>
    </div>
    <div class="col-md-3">
      <app-field [control]="formGroup.get('postalCode')" [config]="{ label: 'Código postal', type: 'text', required: true }">
      </app-field>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-md-12">
      <h6 class="fw-bold mb-3">Contacto y Configuración Regional</h6>
    </div>
    <div class="col-md-4">
      <app-field [control]="formGroup.get('phone')" [config]="{ label: 'Teléfono', type: 'text' }">
      </app-field>
    </div>
    <div class="col-md-4">
      <app-field [control]="formGroup.get('email')" [config]="{ label: 'Email', type: 'email' }">
      </app-field>
    </div>
    <div class="col-md-4">
      <app-autocomplete [control]="formGroup.get('timeZoneId')" [config]="{
        label: 'Zona horaria',
        placeholder: 'Seleccionar zona horaria...',
        options: timeZonesOptions,
        required: true
      }">
      </app-autocomplete>
    </div>
    <div class="col-md-4">
      <app-autocomplete [control]="formGroup.get('currencyCode')" [config]="{
        label: 'Moneda',
        placeholder: 'Seleccionar moneda...',
        options: currencyCodesOptions,
        required: true
      }">
      </app-autocomplete>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-md-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Horario general</mat-label>
        <textarea matInput formControlName="businessHours" rows="4"
          placeholder="Lunes a viernes: 9:00 - 18:00&#10;Sábados: 10:00 - 14:00&#10;Domingos: cerrado"></textarea>
        <mat-hint>Campo informativo. No afecta la disponibilidad de reservas.</mat-hint>
        <mat-error *ngIf="formGroup.get('businessHours').hasError('maxlength')">
          Máximo 1000 caracteres
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-md-12">
      <h6 class="fw-bold mb-3">Configuración Avanzada (Opcional)</h6>
    </div>
    <div class="col-md-4">
      <app-field [control]="formGroup.get('latitude')" [config]="{ label: 'Latitud', type: 'number', placeholder: 'ej: 40.4168' }">
      </app-field>
    </div>
    <div class="col-md-4">
      <app-field [control]="formGroup.get('longitude')" [config]="{ label: 'Longitud', type: 'number', placeholder: 'ej: -3.7038' }">
      </app-field>
    </div>
  </div>

</form>